import {
  VaroAdvanceProductsQualified,
  VaroAdvanceProductsResultTypenames,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import { segmentClient } from 'services/analytics/segment/segment';
import {
  ONBOARDING,
  PROGRESS_TRACKER_FUNDING,
  VARO_ADVANCE,
} from 'shared/constants/onboarding';

export type AdvanceFlow =
  typeof VARO_ADVANCE | typeof ONBOARDING | typeof PROGRESS_TRACKER_FUNDING;

interface HandleEligibilityNavigationParams {
  status: VaroAdvanceProductsResultTypenames | null;
  advanceProductsQualified: VaroAdvanceProductsQualified | null;
  flow?: AdvanceFlow;
  skipDdPrompt?: boolean;
}

const handleEligibilityNavigation = ({
  status,
  advanceProductsQualified,
  flow = VARO_ADVANCE,
  skipDdPrompt = false,
}: HandleEligibilityNavigationParams) => {
  if (!status) {
    return;
  }

  switch (status) {
    case VaroAdvanceProductsResultTypenames.VaroAdvanceProductsQualified:
      if (advanceProductsQualified?.isFirstTime) {
        void segmentClient.logEvent('VA Day 0 Eligible', {
          category: 'varo_advance',
          subcategory: 'va_day_0',
        });
        router.dismissTo('/varo-advance/employment-info');
      } else if (skipDdPrompt) {
        router.dismissTo({
          pathname: '/varo-advance/new',
          params: { skipDdPrompt: 'true' },
        });
      } else {
        router.dismissTo('/varo-advance/new');
      }
      break;
    case VaroAdvanceProductsResultTypenames.VaroAdvanceProductsNotQualified:
      void segmentClient.logEvent('VA Day 0 Ineligible', {
        category: 'varo_advance',
        subcategory: 'va_day_0',
        source_name: 'va_ineligibility',
      });
      router.dismissTo({
        pathname: `/${flow}/link-account/eligibility`,
        params: {
          ineligibility: 'true',
        },
      });
      break;
    case VaroAdvanceProductsResultTypenames.VaroAdvanceProductsPendingEligibility:
      router.dismissTo(`/${flow}/link-account/pending`);
      break;
    default:
      router.dismissTo(`/${flow}/link-account/pending`);
      break;
  }
};

export default handleEligibilityNavigation;
